import React from 'react';
import { Col, Form, Select } from 'antd';
import { ITourOtherTransInfo } from '../../../RefundTypes/RefundTypes';
import { commonProps } from '../../../../../common/types/commonTypes';

type PropsType = {
  otherTransData?: ITourOtherTransInfo[];
} & commonProps;

export const SelectOtherTransRefund = ({
  name,
  label,
  size,
  required,
  disabled,
  otherTransData,
}: PropsType) => {
  const tourInvoiceDataChildren: React.ReactNode[] = [];
  if (otherTransData) {
    for (let i = 0; i < otherTransData.length; i++) {
      tourInvoiceDataChildren.push(
        <Select.Option
          key={otherTransData[i].itinerary_id}
          value={otherTransData[i].itinerary_id}
        >
          {`${otherTransData[i].itinerary_particular}`}
        </Select.Option>
      );
    }
  }
  return (
    <Col span={6} xs={24} sm={24} md={24} lg={size ? size : 8}>
      <Form.Item
        name={name}
        label={label}
        rules={[
          {
            required: required,
            message: 'Select Other Transport Itenery is required',
          },
        ]}
      >
        <Select
          allowClear
          disabled={disabled}
          placeholder={label}
          showSearch
          style={{ padding: '0', margin: '0', border: '0' }}
          optionFilterProp='roleMobile'
          filterOption={(input, option) =>
            (option!.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          mode='multiple'
        >
          {tourInvoiceDataChildren}
        </Select>
      </Form.Item>
    </Col>
  );
};
